/* eslint-disable indent */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Row,
  Col,
  Spin,
  Select,
  Input,
  Button,
  Card,
  Empty,
  message,
  notification,
  Tooltip,
  AutoComplete,
} from "antd";
import useClientAndDepartment from "./useClientAndDepartment ";
import AutoSelectAndType from "./AutoSelectAndType";
import AutoCompleteAddress from "./AutoCompleteAddress";
import { InfoCircleOutlined, CloseOutlined } from "@ant-design/icons";

import {
  capitalize,
  checkNumbervalue,
  checkSpace,
  checkSpecialCharacter,
  getCurretRole,
  isValidAwbForCredit,
  isValidDocumentNum,
  preventTextPaste,
  handleFocusEffect,
} from "../../../utils";
import { HeaderWithBottomLine } from "../../Master/CpOnbordingSteps/HeaderWithBottomLine";
import DoxAndNonDox from "./DoxAndNonDox";
import { DiffOutlined } from "@ant-design/icons";
import { ReactComponent as AttachFile } from "../../../assests/images/FileEarmarkPlus.svg";
import UploadDocument from "./UploadDocument";

function CreditFormItems({
  // Loading & Callback Functions
  eWayBillHandle = () => {}, // Function
  onFormSubmit = () => {}, // Function
  handleFilter = () => {}, // Function
  handleService = () => {}, // Function
  handleFormValueChange = () => {},

  // Form and Validation
  form, // State
  docValidate, // Function
  setMainEwayValidationStatus, // Function
  mainEwayValidationStatus, // State

  // Freight and Packet Changes
  id,
  docLoading,

  // Options and Configurations
  insuredOptions, // State
  travelByOptions, // State
  servicesOptions, // State
  pinCodeServiceableStatus, // State

  // Eway Bills & Child Shipments
  allEwayBills, // State
  childShipments, // State

  // Reviver & Address Details
  reviverNameAndAddress, // State
  setPinCodeServiceableStatus, // Function
  getDeliveryPincode = () => {}, // Function

  // Miscellaneous
  handleOnEnter = () => {}, // Function
  isNonDox, // State

  // AutoComplete and Pincode Options
  filteredOptions, // State
  handleAPIKeyDown = () => {}, // Function
  handleKeyDown = () => {}, // Function
  handleDocumentInputChange = () => {}, // Function
  handleValidationError = () => {}, // Function
  handlePincodeSearch = () => {}, // Function
  uploadDocumentCallback = () => {}, // Function,
  setFileList,
  fileList,
  filesData,
  allPinOptions, // State
  setActivePinOption, // Function

  // Shipment and Department Configurations
  getDepartMentQA = () => {}, // Function
  setClientDepartment, // Function
  department, // State
  dropDownChanges, // State
  setdropDownChanges, // Function
  handleShipmentTypeChange = () => {}, // Function
  contentDiscriptionOptions, // State
  filterOptionforService = () => {}, // Function

  // Alert and Drawer Configurations
  alertData, // State
  clientAdmin,
  setUseGoogleAddr, // Function
  nonDoxValueReq, // State
  setNonDoxValueReq, // Function
  setEwayBillCheck, // Function
  shipmentContentOptions, // State
  setEwayDrawer, // Function
  ewayBillCheck, // State
  setChildDrawer, // Function
  setRadioActive,
  setAllEwayBills,

  // Loading Indicator
  loading, // State
  clientEditChargeVal,
  disableEdit,
  resetForm,
  editShipmentDetails,
  pincodeLoading,

  handleTabEnter,
}) {
  const currentEnv = process.env.REACT_APP_ENV;
  const [number, setNumber] = useState(3);
  const debounceTimeout = useRef(null);
  const debounceTimeoutTab = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setNumber(18);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isClientAdmin = getCurretRole();

  let docOptions = [
    {
      value: "kyc",
      label: "KYC",
    },
    {
      value: "invoiceDeclaration",
      label: "INVOICE",
    },
    {
      value: "ewayBillPrint",
      label: "E-WAYBILL",
    },
    {
      value: "others",
      label: "OTHERS",
    },
  ];

  const [docAdded, setDocAdded] = useState(null);

  // const inputSuffix = React.useMemo(() => {
  //   return docLoading ? <Spin size="small" /> : null;
  // }, [docLoading]);

  // useEffect(() => {
  //   if (docValidate?.status == "error") {
  //     const nextInput = document.getElementById("documentNumber");
  //     if (nextInput) {
  //       nextInput.focus();
  //     }
  //   }
  // }, [docValidate]);

  //--Barcode Scanner--//
  let barcode = "";
  let interval;

  const handleKeyDown_ = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      console.log(barcode, "barcode");

      console.log(barcode?.length, "barcode lenght");

      if (barcode?.length == 11 || barcode?.length == 14) {
        if (barcode) handleDocumentInputChange(barcode, "gunPress");
        barcode = "";
        return;
      } else {
        handleValidationError("Doc number must be 11 or 14 digits gun");
      }
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  return (
    <Form
      layout="vertical"
      // onKeyDown={(e) => console.log(e, "Focused Input")}
      form={form}
      scrollToFirstError={{
        behavior: "smooth",
        block: "center",
        inline: "center",
      }}
      onValuesChange={(e, b) => handleFormValueChange(e, b)}
      onFinish={onFormSubmit}
      className="global-form"
      initialValues={{ returnAddressDetail: [""], insured: "NO" }}
      onFinishFailed={({ errorFields }) => {
        if (errorFields?.length > 0) {
          const firstErrorField = errorFields[0]?.name?.[0];
          const firstElement = document.getElementById(firstErrorField);
          if (firstElement) {
            firstElement.focus();
          }
        }
      }}
    >
      <HeaderWithBottomLine
        text="Sender Details"
        icon={false}
      ></HeaderWithBottomLine>
      <Row className="global-form-row" gutter={16}>
        {!isClientAdmin ? (
          <>
            <Col lg={8} md={8}>
              <Form.Item
                name="clientName"
                label="Client"
                rules={[
                  {
                    required: true,
                    message: "Select client",
                  },
                ]}
              >
                <Select
                  showAction={["focus", "click"]}
                  disabled={disableEdit}
                  // id="cashFirst"
                  placeholder="Select client"
                  showSearch
                  onSearch={handleFilter}
                  onSelect={(value, obj) => {
                    setRadioActive("default");
                    if (currentEnv == "qa") {
                      getDepartMentQA(obj);
                    } else {
                      setClientDepartment(obj);
                    }
                  }}
                  onKeyDown={(event) =>
                    handleAPIKeyDown(
                      event,
                      filteredOptions,
                      "clientName",
                      "label",
                      "clients"
                    )
                  }
                  defaultActiveFirstOption
                  filterOption={false}
                  options={filteredOptions}
                ></Select>
              </Form.Item>
            </Col>
            <Col lg={6} sm={6}>
              <Form.Item
                name="department"
                label="Department"
                rules={[
                  {
                    required: disableEdit ? false : true,
                    message: "Select department",
                    validateTrigger: "onSubmit",
                  },
                ]}
              >
                <Select
                  disabled={disableEdit}
                  showAction={["focus", "click"]}
                  placeholder="Select department"
                  options={department}
                  onSelect={(value, obj) => {
                    setClientDepartment(null, obj);
                  }}
                  // onKeyDown={(event) =>
                  //   handleAPIKeyDown(
                  //     event,
                  //     department,
                  //     "department",
                  //     "label",
                  //     "department"
                  //   )
                  // }
                  onKeyDown={(event) =>
                    handleKeyDown(
                      event,
                      department,
                      "department",
                      "label",
                      "department"
                    )
                  }
                ></Select>
              </Form.Item>
            </Col>
          </>
        ) : null}

        <Col lg={8} sm={8}>
          <div className="space-between">
            <span style={{ width: "93%" }}>
              <Form.Item
                label="Document Number"
                name="documentNumber"
                id="documentNumber"
                validateStatus={docValidate?.status}
                help={docValidate?.message}
                rules={[
                  {
                    required: true,
                    message: "Enter document number",
                  },
                ]}
                // onKeyPress={(event) => {
                //   if (checkNumbervalue(event)) {
                //     event?.preventDefault();
                //   }
                // }}
                onKeyPress={(event) => {
                  if (
                    checkNumbervalue(event) ||
                    checkSpace(event) ||
                    checkSpecialCharacter(event)
                  ) {
                    console.log(event, "event");
                    event.preventDefault();
                    handleOnEnter(event);
                  }
                }}
              >
                <Input
                  placeholder="Enter document number"
                  id="documentNumber"
                  disabled={disableEdit}
                  maxLength={14}
                  onInput={(e) => preventTextPaste(e, 14)}
                  onChange={(e) => {
                    const value = e?.target?.value || "";
                    setTimeout(() => {
                      handleDocumentInputChange(value);
                    }, 50);
                  }}
                  // onChange={(e) => {
                  //   handleDocumentInputChange(e.target.value, "onPressEnter");
                  // }}

                  // onChange={(e) => {
                  //   if (
                  //     e?.target?.value?.length == 11 ||
                  //     e?.target?.value?.length == 14
                  //   ) {
                  //     console.log(e?.target?.value, "iff");
                  //     handleDocumentInputChange(e.target.value, "onPressEnter");
                  //   } else {
                  //     console.log(e?.target?.value, "e?.target?.value else");
                  //     handleValidationError("Document number must be 11 or 14");
                  //   }
                  // }}
                  // onKeyDown={handleKeyDown_}
                />
              </Form.Item>
            </span>
            <span style={{ width: "5%", marginTop: "13px" }} className="ml-1">
              {docLoading ? <Spin size="small" /> : null}
            </span>
          </div>
        </Col>
        <Col lg={8} sm={8} className="deliveryPinInput">
          <Form.Item
            name="deliveryPincode"
            id="deliveryPincode"
            label="Delivery PIN code"
            // className="pincode"
            validateStatus={pinCodeServiceableStatus?.status}
            help={pinCodeServiceableStatus?.msg}
            rules={[
              {
                required: true,
                message: "Enter delivery pincode",
              },
              () => ({
                validator(rule, value = "") {
                  if (value?.length > 0 && value?.length < 6) {
                    return Promise.reject("Pincode should be 6 digits");
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <AutoComplete
              options={allPinOptions}
              disabled={disableEdit}
              onSearch={handlePincodeSearch}
              defaultActiveFirstOption
              onSelect={(value, obj, c) => {
                getDeliveryPincode(value, id, form.getFieldValue("service"));
              }}
              onFocus={() => setdropDownChanges(!dropDownChanges)}
              onKeyDown={(event) => {
                setActivePinOption(null);
                handleKeyDown(event, allPinOptions, "deliveryPincode", "value");
              }}
            >
              <Input
                type="number"
                // maxLength={6}
                onInput={(e) => preventTextPaste(e, 6)}
                onChange={(e) => {
                  if (e?.target?.value?.length == 6) {
                    if (debounceTimeout.current) {
                      clearTimeout(debounceTimeout.current);
                    }
                    debounceTimeout.current = setTimeout(() => {
                      getDeliveryPincode(
                        e?.target?.value,
                        id,
                        form.getFieldValue("service")
                      );
                    }, 200);
                  } else {
                    setPinCodeServiceableStatus({
                      serviceability: null,
                      // status: "success",
                      msg: null,
                      stateCode: null,
                      city: null,
                      districtIp: null,
                    });
                  }
                }}
                placeholder="Enter delivery pincode"
                suffix={
                  pincodeLoading ? (
                    <Spin size="small" />
                  ) : (
                    <span
                      className={
                        pinCodeServiceableStatus?.serviceability
                          ? "green"
                          : "red"
                      }
                    >
                      <Tooltip
                        title={
                          pinCodeServiceableStatus?.city?.length > number
                            ? pinCodeServiceableStatus?.city
                            : null
                        }
                      >
                        {pinCodeServiceableStatus?.city?.length > number
                          ? pinCodeServiceableStatus?.city?.slice(0, number) +
                            "..."
                          : pinCodeServiceableStatus?.city}
                        {pinCodeServiceableStatus?.city ? "-" : null}
                        {pinCodeServiceableStatus?.stateCode}
                      </Tooltip>
                    </span>
                  )
                }
              />
            </AutoComplete>
          </Form.Item>
        </Col>
        {/* {isClientAdmin && <Col lg={6} sm={6} md={6}></Col>} */}
        <Col lg={6} sm={6} md={6}>
          <Form.Item
            // style={{ width: "65%" }}
            name="shipmentType"
            label="Type"
            rules={[
              {
                required: true,
                message: "Enter value",
              },
            ]}
          >
            <Select
              disabled={disableEdit}
              showAction={["focus", "click"]}
              showSearch={true}
              placeholder="Select DOX type"
              // defaultOpen
              className="shipmentType"
              onChange={handleShipmentTypeChange}
              onKeyDown={(event) =>
                handleKeyDown(
                  event,
                  contentDiscriptionOptions,
                  "shipmentType",
                  "value"
                )
              }
              options={contentDiscriptionOptions}
            ></Select>
          </Form.Item>
        </Col>
        <Col lg={4} sm={6}>
          <Form.Item
            label="Service"
            name="service"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              showSearch
              disabled={disableEdit}
              showAction={["focus", "click"]}
              filterOption={filterOptionforService}
              popupClassName="credit-service-dropDown"
              className="pincodeType-placecholder"
              placeholder="Select service"
              // onChange={handleService}
              onKeyDown={(event) =>
                handleKeyDown(event, servicesOptions, "service", "value")
              }
              options={servicesOptions}
            />
          </Form.Item>
        </Col>
        <Col lg={4} sm={4}>
          <Form.Item
            // style={{ width: "77%" }}
            name="travelBy"
            rules={[
              {
                required: true,
                message: "Select  value",
              },
            ]}
            label="Travel by"
          >
            <Select
              showSearch
              disabled={disableEdit}
              filterOption={(input, option) => {
                const searchText = input?.toLowerCase();
                const label = option?.label.toLowerCase();

                if (
                  searchText?.includes("a") &&
                  label?.toUpperCase() === "SURFACE"
                ) {
                  return false;
                }

                return label?.includes(searchText);
              }}
              showAction={["focus", "click"]}
              className="pincodeType-placecholder"
              placeholder="Select  Travel by"
              onKeyDown={(event) =>
                handleKeyDown(event, travelByOptions, "travelBy", "value")
              }
              options={travelByOptions}
            />
          </Form.Item>
        </Col>

        <Col lg={9} sm={9}></Col>
        <Col lg={24} sm={24}>
          <HeaderWithBottomLine text="Receiver details" icon={false} />
        </Col>

        <Col lg={6} sm={6}>
          <AutoSelectAndType
            form={form}
            bookType={"Account"}
            fieldName="receiverName"
            reviverNameAndAddress={reviverNameAndAddress?.receiverDetails}
          />
        </Col>
        <Col lg={8} sm={8}>
          <AutoCompleteAddress
            form={form}
            returnAddress={false}
            resetForm={resetForm}
            handleTabEnter={handleTabEnter}
            alertData={alertData}
            // userInfo={userInfo}
            setUseGoogleAddr={setUseGoogleAddr}
            // addressDetailsCallback={null}
            fieldName="receiverAddress"
            label="Receiver address"
            rules={[
              {
                required: true,
                message: "Enter receiver address",
              },
            ]}
          />
        </Col>
        <Col span={4}>
          <Form.Item
            label="Mobile number"
            name="mobileNumber"
            rules={[
              {
                required: true,
                message: null,
              },
              () => ({
                validator(rule, value = "") {
                  if (!value && !value?.length) {
                    return Promise.reject("Enter mobile number");
                  }
                  if (value?.length > 0 && value?.length < 10) {
                    return Promise.reject("Enter 10 digits number");
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <Input
              type="number"
              maxLength={10}
              onInput={(e) => preventTextPaste(e, 10)}
              placeholder="Enter phone number"
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  handleOnEnter(e);
                } else if (/[^0-9]/.test(e?.key)) {
                  e?.preventDefault();
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Email "
            name="receiverEmail"
            rules={[
              {
                type: "email",
                message: "Give the correct email",
              },
            ]}
          >
            <Input
              placeholder="Enter email"
              onKeyPress={(e) => {
                if (e?.key == "Enter") {
                  handleOnEnter(e);
                }
              }}
              onBlur={(e) =>
                form.setFieldValue(
                  "returnEmail",
                  e?.target?.value?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>
        </Col>
      </Row>

      <div>
        <HeaderWithBottomLine
          text={"Service & Shipment Details"}
          icon={false}
        />
        <hr className="divider" style={{ margin: "2px" }} />
      </div>

      <Row className="global-form-row" gutter={16}>
        <DoxAndNonDox
          disableEdit={disableEdit}
          form={form}
          isNonDox={isNonDox}
          nonDoxValueReq={nonDoxValueReq}
          setNonDoxValueReq={setNonDoxValueReq}
          handleTabEnter={handleTabEnter}
          handleOnEnter={handleOnEnter}
          // ewayBillCheck={ewayBillCheck}
          ewayBillValueCheck={(value) => setEwayBillCheck(value)}
          childShipments={childShipments}
          shipmentContentOptions={shipmentContentOptions}
          handleKeyDown={handleKeyDown}
          editShipmentDetails={editShipmentDetails}
        />

        <div style={{ width: "8%" }}>
          <Form.Item name="insured" label="Insured">
            <Select
              showSearch
              disabled={disableEdit}
              //  showAction={["focus", "click"]}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  ?.toLowerCase()
                  ?.includes(input?.toLowerCase())
              }
              showAction={["focus", "click"]}
              className="pincodeType-placecholder"
              placeholder="Select insured"
              optionFilterProp="children"
              onKeyDown={(event) =>
                handleKeyDown(event, insuredOptions, "insured", "value")
              }
              options={insuredOptions}
            ></Select>
          </Form.Item>
        </div>

        <Col lg={4} sm={6} md={4}>
          <Form.Item
            validateStatus={mainEwayValidationStatus?.status}
            help={mainEwayValidationStatus?.msg}
            label={"Eway bill"}
            // disabled={edit !== null ? true : false}
            name="ewayBill0"
            // styles={styles}
            rules={[
              {
                required: ewayBillCheck && allEwayBills?.length === 0,
                message: "Enter Eway-bill",
              },
              // EwayValidator(),
            ]}
            onKeyPress={(event) => {
              if (event.key == "Enter") {
                handleOnEnter(event, "billRemark");
              } else if (checkNumbervalue(event) || event.key === ".") {
                event.preventDefault();
              }
            }}
          >
            <Input
              maxLength={12}
              placeholder="Enter Eway-bill"
              onChange={(e) => {
                if (e?.target?.value?.length == 0) {
                  setMainEwayValidationStatus({
                    status: "success",
                    msg: null,
                  });
                  let temp = [...allEwayBills]?.filter(
                    (val) => val?.editable == true
                  );
                  setAllEwayBills(temp);
                } else {
                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current);
                  }
                  debounceTimeout.current = setTimeout(async () => {
                    eWayBillHandle(e?.target?.value, 0);
                  }, 700);
                }
              }}
            />
          </Form.Item>
        </Col>

        <div style={{ paddingTop: "22px" }} className="flex-column">
          <Button
            type="secondary"
            className={
              allEwayBills?.length > 0
                ? "eway-Child-Active"
                : "eway-Child-InActive"
            }
            // size={"large"}
            style={{
              height: "32px",
              width: "max-content",
              padding: "0 6px",
              display: "flex",
              alignItems: "center",
              fontSize: "12px",
            }}
            onFocus={(e) => handleFocusEffect(e, true)}
            onBlur={(e) => handleFocusEffect(e, false)}
            onClick={() => setEwayDrawer(true)}
            onKeyPress={(e) => e.key === "Enter" && setEwayDrawer(true)}
          >
            <span>Multi E-ways</span>
            <DiffOutlined width={13} height={13} />{" "}
          </Button>
          <div>
            {allEwayBills?.length > 0 ? (
              <span style={{ color: "#50CD89", fontSize: "12px" }}>
                {allEwayBills?.length} E-way Bill added
              </span>
            ) : null}
          </div>
        </div>

        {isNonDox ? (
          <>
            <Col style={{ paddingTop: "22px" }} className="flex-column">
              <Button
                type="secondary"
                id="childBtn"
                className={
                  childShipments?.length > 0
                    ? "eway-Child-Active"
                    : "eway-Child-InActive"
                }
                // size={"large"}
                style={{
                  height: "32px",
                  padding: "0 5px",
                  width: "max-content",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "12px",
                }}
                onFocus={(e) => handleFocusEffect(e, true)}
                onBlur={(e) => handleFocusEffect(e, false)}
                onClick={() => setChildDrawer(true)}
                onKeyPress={(e) => e.key === "Enter" && setChildDrawer(true)}
              >
                <span className="pr-05"> Child Badge</span>
                <AttachFile width={12} height={12} />
              </Button>
              <div>
                {childShipments?.length > 0 ? (
                  <span style={{ color: "#50CD89" }}>
                    {childShipments?.length} child added
                  </span>
                ) : null}
              </div>
            </Col>
          </>
        ) : null}
        {disableEdit && (
          <Col span={3}>
            <Form.Item
              label={
                <>
                  <label>
                    Charges
                    <span style={{ marginLeft: 5 }}>
                      <Tooltip
                        placement="right"
                        title="If charges is 0 then wait for 30 minutes for charges to be updated"
                      >
                        <InfoCircleOutlined />
                      </Tooltip>
                    </span>
                  </label>
                </>
              }
              name="clientCharges"
              rules={[
                {
                  required: true,
                  message: "Enter charges",
                },
                () => ({
                  validator(_, value) {
                    if (value === null || value === undefined || value === "") {
                      return Promise.reject("");
                    }

                    if (Number(value) < clientEditChargeVal) {
                      return Promise.reject(
                        "Charges cannot be less than original charge -" +
                          clientEditChargeVal
                      );
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
              onKeyPress={(e) => {
                if (e?.key == "Enter") {
                  handleOnEnter(e);
                }
              }}
            >
              <Input
                placeholder="Enter charges"
                type="number"
                disabled={clientEditChargeVal == 0}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row
        align="middle"
        justify="space-between"
        style={{ width: "100%" }}
        className="global-form-row"
      >
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div style={{ width: "20%", marginRight: "8px" }}>
            <Form.Item
              label="Upload document"
              name="docType"
              rules={[
                {
                  required: false,
                  message: "Select type",
                },
              ]}
            >
              <Select
                showAction={["focus", "click"]}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                // onKeyDown={(event) =>
                //   handleKeyDown(event, payOptions, "paymentMode", "value")
                // }
                // onKeyPress={(event) => {
                //   if (event.code == "Enter") {
                //     handleOnEnter(event);
                //   }
                // }}
                onClear={() => setDocAdded(null)}
                onSelect={(e) => setDocAdded(e)}
                className="pincodeType-placecholder"
                placeholder="Select doc type"
                options={docOptions}
              />
            </Form.Item>
          </div>

          <div>
            <Form.Item label="Bill remark" name="billRemark">
              <Input
                placeholder="Enter remark"
                onKeyPress={(event) => {
                  if (event.key == "Enter") {
                    event.preventDefault();
                    const inputFieldId = "submit_credit";
                    const targetElement = document.getElementById(inputFieldId);
                    if (targetElement) {
                      targetElement.focus();
                    }
                  }
                }}
                onInput={(e) =>
                  (e.target.value = e?.target?.value?.toUpperCase() || "")
                }
              />
            </Form.Item>
          </div>

          <div style={{ marginLeft: "auto" }}>
            <Button
              htmlType="submit"
              id="submit_credit"
              // loading={loading}
              disabled={loading || docLoading || pincodeLoading}
              className="btn-style cancel-btn ml-1"
              onKeyDown={(event) => {
                if (event.key === "Tab") {
                  event.preventDefault();

                  form.submit();
                  window.scrollTo(0, 0);
                } else if (event.key === "Enter") {
                  event.preventDefault();

                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current);
                  }

                  debounceTimeout.current = setTimeout(() => {
                    form.submit();
                  }, 300);
                }
              }}
              onFocus={(e) => handleFocusEffect(e, true)}
              onBlur={(e) => handleFocusEffect(e, false)}
            >
              {disableEdit ? "UPDATE BOOKING" : "CONFIRM BOOKING"}
            </Button>
          </div>
        </div>
      </Row>
      <Row>
        {docAdded || fileList?.length ? (
          <UploadDocument
            docAdded={docAdded}
            setFileList={setFileList}
            fileList={fileList}
            filesData={filesData}
          />
        ) : null}
      </Row>

      <hr className="divider" />
    </Form>
  );
}

export default CreditFormItems;
